import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);

  const x = useMotionValue(-100);
  const y = useMotionValue(-100);

  const dotX = useSpring(x, { stiffness: 600, damping: 40, mass: 0.4 });
  const dotY = useSpring(y, { stiffness: 600, damping: 40, mass: 0.4 });
  const glowX = useSpring(x, { stiffness: 120, damping: 18, mass: 0.6 });
  const glowY = useSpring(y, { stiffness: 120, damping: 18, mass: 0.6 });

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (!fine) return;
    setEnabled(true);

    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const t = e.target;
      if (t.closest && t.closest("a, button, [role='button'], input, textarea, label, [data-cursor='hover']")) {
        setHovering(true);
      }
    };
    const out = (e) => {
      const t = e.target;
      if (t.closest && t.closest("a, button, [role='button'], input, textarea, label, [data-cursor='hover']")) {
        setHovering(false);
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    window.addEventListener("mouseout", out);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      window.removeEventListener("mouseout", out);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className="cp-cursor-glow"
        data-testid="custom-cursor-glow"
        style={{ x: glowX, y: glowY, scale: hovering ? 2.2 : 1 }}
        transition={{ scale: { duration: 0.35 } }}
      />
      <motion.div
        className="cp-cursor-dot"
        data-testid="custom-cursor-dot"
        style={{ x: dotX, y: dotY, scale: hovering ? 0.4 : 1 }}
        transition={{ scale: { duration: 0.25 } }}
      />
    </>
  );
};

export default CustomCursor;
